var render = function render(){var _vm=this,_c=_vm._self._c;return _c('selection-base',{attrs:{"value":_vm.value,"items":_vm.items,"item-value":"id","item-text":"name","label":_vm.$t('status'),"placeholder":_vm.$t('placeholder.select-status-power-ball')},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }